import React, { useEffect } from "react";
import FirebaseAnalytics from "../services/analytics.service";
import Storage from "../services/storage.service";
import SimDeactivationForm from "../views/simDeactivation/index";
import SimDeactivationStepper from "../views/simDeactivation/stepper";

export default function SimDeactivationUI(props) {
	useEffect(() => {
		FirebaseAnalytics.basicEvent(6);
		const checkRoute = Storage.get("simDeactivationRoute", true);
		const getFormData = Storage.get("simDeactivationData", true);
		if(checkRoute) {
			switch (checkRoute) {
				case "closingSummary":
					if(getFormData) {
						const formData = JSON.parse(getFormData);
						const formValues = {
							phone: formData.phone,
							idNumber: formData.idNumber,
							idType: formData.idType,
							contact: formData.contact,
							IBAN: formData.IBAN,
							reason: formData.reason
						}
						props.history.push({
							pathname: '/sim-deactivation/bill-summary',
							state: { formValues: formValues }
						});
					}
					break;
				default:
					break;
			}
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className="storefront-two-col-pg">
			<SimDeactivationForm props={props}/>
			<SimDeactivationStepper />
		</div>
	)
}